import { useAppSelector } from "@src/reduxStore";
import { FC } from "react";

export interface LinkToUpdaterProfileProps {
  userId?: string;
}

const LinkToUpdaterProfile: FC<LinkToUpdaterProfileProps> = ({
  children,
  userId,
}) => {
  const config = useAppSelector(state => state.common.config);
  if (!userId) {
    return null;
  }
  return (
    <a
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      href={`${config?.portalUrl}/#/search-users-globally/view-user/${userId}`}
      target="_blank"
      rel="noreferrer noopener"
    >
      {children}
    </a>
  );
};

export default LinkToUpdaterProfile;
